import React from "react";
import { Stack, Table } from "@mui/material";

import { HubCircularProgress } from "../HubCircularProgress";
import { HubPagination } from "../HubPagination";
import HubTableHeader from "../HubTable/HubTableHeader/HubTableHeader";
import HubTableBody from "./HubTableBody";
import { StyledTableContainer } from "./styles";

export const HubTableTemplate = ({
  id,
  headerProps = {},
  bodyProps = {},
  meta = {},
  isLoading = false,
  showPagination = false,
  ...rest
}) => {
  return isLoading ? (
    <HubCircularProgress centerScreen />
  ) : (
    <Stack
      gap="10px"
      width="100%"
      height="100%"
      overflow="hidden"
      className="HubTableTemplate-stack"
    >
      <StyledTableContainer {...rest}>
        <Table id={id}>
          <HubTableHeader
            includeCheckbox={false}
            includeEnd={false}
            {...headerProps}
          />
          <HubTableBody {...bodyProps} />
        </Table>
      </StyledTableContainer>
      {meta?.count > 25 || showPagination ? <HubPagination {...meta} /> : <></>}
    </Stack>
  );
};

export default HubTableTemplate;
